import { OriginSectionEditorAccordion } from '@components/Pages/LettersPage/OriginSectionEditorAccordion';
import { useDispatch, useSelector } from 'react-redux';
import { currentSubmissionOriginSections } from '@selectors/submission';
import React, { useCallback, useState } from 'react';
import { DragDrop as DragDropArea, DragResult } from '@sharedComponents/DragDrop';
import { OriginEntitySectionsOriginSectionEntityInterface } from '@types';
import { DragDrop } from '@images/icons';
import { updateCurrentSubmissionOriginSectionsOrder } from '@actions/submissionActions';
import cx from 'classnames';

export const OriginEditorContainer = () => {
  const originSectionsWithOrder = useSelector(currentSubmissionOriginSections);
  const dispatch = useDispatch();
  const [disabledToDragIds, setDisabledToDragIds] = useState<string[]>([]);

  const onSectionDragEnd = useCallback(
    (result: DragResult) => {
      if (!result.destination) {
        return;
      }

      const startIndex = result.source.index;
      const endIndex = result.destination.index;
      dispatch(updateCurrentSubmissionOriginSectionsOrder(startIndex, endIndex));
    },
    [dispatch]
  );

  const onAccordionCloseOpen = useCallback(
    (isAccordionOpened: boolean, sectionId: string) => {
      const updatedDisabledToDragIds = [...disabledToDragIds];
      if (isAccordionOpened) {
        updatedDisabledToDragIds.push(sectionId);
        setDisabledToDragIds(updatedDisabledToDragIds);
      }
      if (!isAccordionOpened && disabledToDragIds.includes(sectionId)) {
        const index = updatedDisabledToDragIds.indexOf(sectionId);
        updatedDisabledToDragIds.splice(index, 1);
        setDisabledToDragIds(updatedDisabledToDragIds);
      }
    },
    [disabledToDragIds]
  );
  return (
    <div className="origin-editor-wrapper" data-testid="origin-editor-wrapper">
      {originSectionsWithOrder && (
        <DragDropArea<OriginEntitySectionsOriginSectionEntityInterface>
          onDragEnd={onSectionDragEnd}
          items={originSectionsWithOrder}
          droppableId="section-id"
          disabledToDragIds={disabledToDragIds}
        >
          {({ originSection, id, order }) => (
            <span className="section-drag-wrapper">
              <span
                className={cx('origin-section-editor-wrapper-width-90', {
                  'origin-section-editor-wrapper-width-100': disabledToDragIds.includes(id),
                })}
              >
                <OriginSectionEditorAccordion
                  originSection={originSection}
                  originSectionWithOrderId={id}
                  originSectionOrder={order}
                  key={`${originSection.name}-${order}`}
                  onSectionAccordionOpen={onAccordionCloseOpen}
                />
              </span>
              <span
                className={cx({ 'section-drag-handler-none': disabledToDragIds.includes(id) })}
                data-testid={`drag-icon-${order}`}
              >
                <DragDrop />
              </span>
            </span>
          )}
        </DragDropArea>
      )}
    </div>
  );
};
